// extracted by mini-css-extract-plugin
export default {"teamCardList":"TeamCardList_teamCardList__m73II","teamCard":"TeamCardList_teamCard__yue-Q"};